import React, { Component } from 'react';
import { ChartState } from '../../../../redux/reducers/ChartReducer';
import CustomLoading from '../../../custom/CustomLoading';
import { RootState } from '../../../../redux/store';
import { changeChart, changeChartEditorOptions } from '../../../../redux/actions/ChartActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import DataType from '../../../../constant/DataType';
import { SegmentItem } from '../../../../domain/chart/ChartDomains';
import FormicaSearchSelectBox, { FormicaSelectBoxItem } from '../../../custom/FormicaSearchSelectBox';
import ChartValueFactory from '../../../../util/ChartValueFactory';
import { User } from '../../../../domain/rbac/RbacDomains';
import LanguageUtil from '../../../../util/LanguageUtil';

class SegmentDateHistogram extends Component<Props> {
  render() {
    const { segmentItem } = this.props;
    const dateHistogram = segmentItem?.segments.dateHistogram;
    if (dateHistogram == undefined) return <CustomLoading />;
    return (
      <div id={'date-histogram-container'} className={'w-full h-full flex flex-col rounded gap-y-5'}>
        <div id={'date-histogram-input-container'} className={'flex flex-col gap-y-3'}>
          <div className={'flex flex-col gap-y-1'}>
            <label className={'text-sm text-f-black-2'}>Field</label>
            <FormicaSearchSelectBox
              customSize={'medium'}
              rounded={false}
              value={dateHistogram.field.name}
              onChange={(e) => this.onChangeField(e)}
              placeholder={LanguageUtil.get({ id: 'common.input.placeholder.field', defaultMessage: 'Field' })}
              options={this.getAvailableElasticVariables()}
              id={'segment-field'}
            />
          </div>
          <div className={'flex flex-col gap-y-1'}>
            <label className={'text-sm text-f-black-2'} htmlFor={'interval-select'}>
              Interval
            </label>
            <FormicaSearchSelectBox
              value={dateHistogram.interval}
              onChange={(e: FormicaSelectBoxItem) => this.onChangeInterval(e)}
              options={this.getOptions()}
              customSize={'medium'}
              rounded={false}
              placeholder={LanguageUtil.get({ id: 'common.input.placeholder.intervals', defaultMessage: 'Intervals' })}
              id='interval-select'
            />
          </div>
        </div>
      </div>
    );
  }

  private getOptions = () => {
    return [
      {
        label: 'Millisecond',
        value: 'millisecond',
      },
      {
        label: 'Second',
        value: 'second',
      },
      {
        label: 'Minute',
        value: 'minute',
      },
      {
        label: 'Hour',
        value: 'hour',
      },
      {
        label: 'Day',
        value: 'day',
      },
      {
        label: 'Week',
        value: 'week',
      },
      {
        label: 'Month',
        value: 'month',
      },
      {
        label: 'Year',
        value: 'year',
      },
    ];
  };

  private onChangeField = (e: FormicaSelectBoxItem) => {
    const { segmentItem, onChangeSegmentItem } = this.props;
    const dateHistogram = segmentItem?.segments.dateHistogram;
    if (dateHistogram) {
      dateHistogram.field.name = e.value as string;
      dateHistogram.field.dataType = e.dataType as DataType;
      if (!dateHistogram.interval) {
        dateHistogram.interval = 'day';
      }
      dateHistogram.appearance.name = segmentItem.name = dateHistogram.interval + ' per ' + e.value;
      onChangeSegmentItem(segmentItem);
    }
  };

  private onChangeInterval = (e: FormicaSelectBoxItem) => {
    const { segmentItem, onChangeSegmentItem } = this.props;
    const dateHistogram = segmentItem?.segments.dateHistogram;
    if (dateHistogram) {
      dateHistogram.interval = e.value;
      dateHistogram.appearance.name = dateHistogram.field.name + ' per ' + e.value;
      segmentItem.name = dateHistogram.appearance.name;
      onChangeSegmentItem(segmentItem);
    }
  };

  private getAvailableElasticVariables = () => {
    const {
      chart: { chartEditorOptions },
      user,
    } = this.props;
    const elasticVariables = ChartValueFactory.initializeElasticVariablesForChartMetricAndSegment(user?.activeRiskType as string).filter((field) => {
      return field.dataType == DataType.DATE;
    });
    if (chartEditorOptions.transactionVariables && Array.isArray(chartEditorOptions.transactionVariables)) {
      const variables = chartEditorOptions.transactionVariables
        ?.filter((field) => {
          return field.dataType == DataType.DATE;
        })
        .map((field) => {
          return {
            label: field.label,
            value: field.value,
            dataType: field.dataType,
          };
        });
      return [...elasticVariables, ...variables];
    }
    return [] as FormicaSelectBoxItem[];
  };
}

interface Props extends ReduxProps {
  segmentItem: SegmentItem | null;
  onChangeSegmentItem: (segmentItem: SegmentItem) => void;
}

const mapStateToProps = (state: RootState) => ({
  chart: state.chart as ChartState,
  user: state.auth.user as User,
});

const mapDispatchToProps = { changeChart, changeChartEditorOptions };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(SegmentDateHistogram);
